<template>
  <div class="pane-config-wrap" @contextmenu="$emit('closeRightMenu')">
    <div class="pane-name">
      <Icon icon="zu33680" class="pane-name-icon"></Icon>
      <span class="pane-name-title">{{ currentComponent.chartViews ? '大屏设置' : '组件设置' }}</span>
    </div>
    <!-- 素材-筛选组件配置 -->
    <el-collapse v-if="componentType === 'filterBlock'" v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <!-- 组件尺寸设置 -->
      <el-collapse-item title="尺寸" name="1">
        <div class="component-size">
          <span class="option-size-label">位置</span>
          <span class="opti-sub-label">x</span>
          <el-input-number
            v-model="componentSizeSet.x"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">y</span>
          <el-input-number
            v-model="componentSizeSet.y"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
        <div class="component-size">
          <span class="option-size-label">尺寸</span>
          <span class="opti-sub-label">w</span>
          <el-input-number
            v-model="componentSizeSet.w"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">h</span>
          <el-input-number
            v-model="componentSizeSet.h"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
      </el-collapse-item>
      <!-- 数据设置 -->
      <el-collapse-item title="数据" name="3">
        <div class="border-config">
          <div class="border-config-item">
            <span class="option-label">筛选维度</span>
            <el-radio-group
              :value="currentComponent.chartSet.chartStyle.filterType"
              @input="handleChangeFilterType">
              >
              <el-radio label="date">时间</el-radio>
              <el-radio label="province">省</el-radio>
              <el-radio label="city">省市</el-radio>
              <el-radio label="region">省市区</el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-collapse-item>
      <!-- 组件样式设置 -->
      <el-collapse-item title="样式" name="2">
        <div class="border-config">
          <div class="border-config-item">
            <span class="option-label">背景色</span>
            <el-color-picker
              v-model="currentComponent.chartSet.chartStyle.backgroundColor"
              show-alpha
              :predefine="COLOR_PICKER_LIST">
            </el-color-picker>
          </div>
          <div class="border-config-item">
            <span class="option-label">边框</span>
            <el-color-picker
              v-model="currentComponent.chartSet.chartStyle.borderColor"
              show-alpha
              :predefine="COLOR_PICKER_LIST">
            </el-color-picker>
          </div>

          <div class="border-config-item">
            <span class="option-label">字体</span>
            <el-color-picker
              v-model="currentComponent.chartSet.chartStyle.color"
              :predefine="COLOR_PICKER_LIST" class="style-config-numberColor" />
            <el-select v-model="currentComponent.chartSet.chartStyle.fontSize" style="width: 80px">
              <el-option v-for="item in FONT_SIZE_LIST" :key="item" :value="item" :label="item+'px'"></el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 【素材-边框】组件配置 -->
    <el-collapse v-else-if="componentType === 'borderBlock'" v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <!-- 组件尺寸设置 -->
      <el-collapse-item title="尺寸" name="1">
        <div class="component-size">
          <span class="option-size-label">位置</span>
          <span class="opti-sub-label">x</span>
          <el-input-number
            v-model="componentSizeSet.x"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">y</span>
          <el-input-number
            v-model="componentSizeSet.y"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
        <div class="component-size">
          <span class="option-size-label">尺寸</span>
          <span class="opti-sub-label">w</span>
          <el-input-number
            v-model="componentSizeSet.w"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">h</span>
          <el-input-number
            v-model="componentSizeSet.h"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
      </el-collapse-item>
      <!-- 组件样式设置 -->
      <el-collapse-item title="样式" name="2">
        <div class="border-config">
          <div class="border-config-item">
            <span class="option-label">背景</span>
            <el-color-picker
              v-model="currentComponent.chartSet.chartStyle.background"
              show-alpha
              :predefine="COLOR_PICKER_LIST">
            </el-color-picker>
          </div>
          <div class="border-config-item">
            <span class="option-label">边框</span>
            <el-input-number
              v-model="currentComponent.chartSet.chartStyle.borderWidth"
              class="border-input"
              :min="0"
              :step="1"
              controls-position="right">
            </el-input-number>
            <el-color-picker
              v-model="currentComponent.chartSet.chartStyle.borderColor"
              show-alpha
              :predefine="COLOR_PICKER_LIST">
            </el-color-picker>
          </div>
          <div class="border-config-item">
            <span class="option-label">边框圆角</span>
            <el-input-number
              v-model="currentComponent.chartSet.chartStyle.borderRadius"
              :min="0"
              :step="1"
              controls-position="right">
            </el-input-number>
          </div>
          <div class="border-config-item">
            <span class="option-label">边角</span>
            <el-switch v-model="currentComponent.chartSet.chartStyle.hasCorner" class="corner-switch" @change="handleChangeHasCorner"></el-switch>
            <el-color-picker
              v-if="currentComponent.chartSet.chartStyle.hasCorner"
              v-model="currentComponent.chartSet.chartStyle.cornerColor"
              show-alpha
              :predefine="COLOR_PICKER_LIST">
            </el-color-picker>
          </div>
          <div v-if="currentComponent.chartSet.chartStyle.hasCorner" class="border-config-item">
            <span class="option-label">边角样式</span>
            <el-select ref="borderSelectType" v-model="currentComponent.chartSet.chartStyle.borderType" style="width: 220px" @change="handleBorderSelectType">
              <el-option v-for="item in BORDER_TYPE_LIST" :key="item.value" :value="item.value" :label="' '">
                <Icon :icon="item.label"></Icon>
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 【素材-署名】组件配置 -->
    <el-collapse v-else-if="componentType === 'signName'" v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <!-- 组件尺寸设置 -->
      <el-collapse-item title="尺寸" name="1">
        <div class="component-size">
          <span class="option-size-label">位置</span>
          <span class="opti-sub-label">x</span>
          <el-input-number
            v-model="componentSizeSet.x"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">y</span>
          <el-input-number
            v-model="componentSizeSet.y"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
        <div class="component-size">
          <span class="option-size-label">尺寸</span>
          <span class="opti-sub-label">w</span>
          <el-input-number
            v-model="componentSizeSet.w"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">h</span>
          <el-input-number
            v-model="componentSizeSet.h"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
      </el-collapse-item>
      <!-- 组件样式设置 -->
      <el-collapse-item title="样式" name="2">
        <div class="sign-name-config">
          <div class="sign-name-config-item">
            <span class="option-label">字体颜色</span>
            <el-color-picker v-model="currentComponent.chartSet.chartStyle.textColor" :predefine="COLOR_PICKER_LIST" class="sign-content" />
          </div>
          <div class="sign-name-config-item">
            <div class="option-label">签名者姓名</div>
            <el-input
              v-model="currentComponent.chartSet.chartStyle.signName" class="sign-content"
              @change="handleChangeSignName">
            </el-input>
          </div>
          <div class="tips">每个签名者拥有专属的签名URL，打开大屏，复制签名URL打开即可进行签名</div>
          <div class="sign-name-config-item">
            <div class="option-label">签名URL</div>
            <div class="sign-content">{{ currentComponent.chartSet.chartStyle.signUrl }}</div>
          </div>
        </div>
      </el-collapse-item>
      <!-- 交互 -->
      <el-collapse-item title="交互" name="7">
        <div class="active-config">
          <span class="option-label">点击跳转</span>
          <el-select ref="selectScreen" v-model="currentComponent.jumpPanelSn" placeholder="选择数据大屏" class="active-config-jump" style="width: 220px; background-color:#fff" clearable>
            <el-option v-for="(item,index) in screenList" :key="index" :value="item.panelSn" :label="item.panelName"></el-option>
          </el-select>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 【富文本】组件配置 -->
    <el-collapse v-else-if="componentType === 'richText'" v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <!-- 组件尺寸设置 -->
      <el-collapse-item title="尺寸" name="1">
        <div class="component-size">
          <span class="option-size-label">位置</span>
          <span class="opti-sub-label">x</span>
          <el-input-number
            v-model="componentSizeSet.x"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">y</span>
          <el-input-number
            v-model="componentSizeSet.y"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
        <div class="component-size">
          <span class="option-size-label">尺寸</span>
          <span class="opti-sub-label">w</span>
          <el-input-number
            v-model="componentSizeSet.w"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">h</span>
          <el-input-number
            v-model="componentSizeSet.h"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
      </el-collapse-item>
      <!-- 组件样式设置 -->
      <el-collapse-item title="字体段落" name="1">
        <div class="title-config">
          <div class="title-config-title">
            <span class="option-label">样式设置</span>
            <ul class="set-font-style">
              <li class="set-font-style-item" @click="handleFontStyle('bold')"> <span style="font-weight: bold;">B</span></li>
              <li class="set-font-style-item" @click="handleFontStyle('italic')"> <span style="font-style: italic;">I</span></li>
              <li class="set-font-style-item" @click="handleFontStyle('underline')"> <span style="text-decoration-line: underline;">U</span></li>
              <li class="set-font-style-item" @click="handleFontStyle('strikeThrough')"> <span style="text-decoration-line: line-through;">S</span></li>
            </ul>
          </div>
          <!--颜色、字体、对齐方式 -->
          <el-color-picker
            v-model="currentComponent.chartSet.titleStyle.color"
            :predefine="COLOR_PICKER_LIST" class="title-config-color" @change="handleFontStyle('color')" />
          <el-select v-model="currentComponent.chartSet.titleStyle.fontSize" class="title-config-fontsize" style="width: 80px">
            <el-option v-for="(item, index ) in RICH_FONT_SIZE_LIST" :key="index" :value="index + 1" :label="item" @click.native="handleFontStyle('fontSize')"></el-option>
          </el-select>

          <ul class="set-rich-position">
            <li class="set-rich-position-item" @click="handleJustify('left')"><Icon icon="zu33707" class="1icon"></Icon></li>
            <li class="set-rich-position-item" @click="handleJustify('center')"><Icon icon="zu33708" class="icon"></Icon></li>
            <li class="set-rich-position-item" @click="handleJustify('right')"><Icon icon="zu33709" class="icon"></Icon></li>
          </ul>

          <div>
          </div>
        </div>
      </el-collapse-item>

      <!-- 交互 -->
      <el-collapse-item title="交互" name="7">
        <div v-if="!['number','independentNumber','gaugeNumber','scrollTable','text','richText'].includes(componentType) " class="active-config">
          <span class="option-label">轮播</span>
          <el-switch v-model="currentComponent.chartSet.chartStyle.carousel" :disabled="['mapChart'].includes(componentType)"></el-switch>
          <el-input-number v-model="currentComponent.chartSet.chartStyle.carouselDelay" :min="3" style="margin-left:10px;width:100px;" :step="0.5" controls-position="right"></el-input-number> 秒
        </div>

        <div class="active-config">
          <span class="option-label">点击跳转</span>
          <el-select ref="selectScreen" v-model="currentComponent.jumpPanelSn" placeholder="选择数据大屏" class="active-config-jump" style="width: 220px; background-color:#fff" clearable>
            <el-option v-for="(item,index) in screenList" :key="index" :value="item.panelSn" :label="item.panelName"></el-option>
          </el-select>
        </div>
      </el-collapse-item>
    </el-collapse>

    <!-- 【富文本之外】组件 -->
    <el-collapse v-else v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <!-- 【大屏设置】 -->
      <div v-if="currentComponent.chartViews" key="screen">
        <!-- 尺寸-->
        <el-collapse-item title="尺寸" name="1">
          <div class="size-config">
            <el-radio-group v-model="currentComponent.panelProportion" @change="handleScreenSizeChange">
              <el-radio-button label="16:9">16:9</el-radio-button>
              <el-radio-button label="4:3">4:3</el-radio-button>
              <el-radio-button label="custom">自定义</el-radio-button>
            </el-radio-group>
            <el-form ref="screenSizeForm" class="size-width" :model="form" :rules="rules" :inline="true" @submit.native.prevent="handleSubmit">
              <span style="display:inline-block;margin-right: 12px;">
                <el-form-item prop="panelWidth">
                  <span class="size-label">宽</span>
                  <el-input
                    v-model="form.panelWidth"
                    class="size-width-input"
                    :disabled="currentComponent.panelProportion !== 'custom'" />
                </el-form-item>
              </span>
              <el-form-item prop="panelHeight">
                <span>
                  <span class="size-label">高</span>
                  <el-input
                    v-model="form.panelHeight"
                    :disabled="currentComponent.panelProportion !== 'custom'"
                    class="size-width-input" />
                </span>
              </el-form-item>
              <el-button native-type="submit" style="visibility: hidden;"></el-button>
            </el-form>
          </div>
        </el-collapse-item>
        <!-- 颜色 -->
        <el-collapse-item title="颜色" name="3">
          <div class="color-config">
            <span class="option-label"> 组件配色</span>
            <el-select ref="selectColor" v-model="currentComponent.chartColors" placeholder="选择配色方案" class="color-config-select" style="width: 220px" @change="handleThemeColor">
              <el-option v-for="(item,index) in COLOR_LIST" :key="index" :value="item.label" :label="' '">
                <div>
                  <span v-for="(color,ind) in item.value" :key="ind" style="display:inline-block; width:17px;height:17px" :style="{backgroundColor:color}"></span>
                  <span class="color-name" style="display:inline-block; margin-left: 6px;vertical-align: 4px">{{ item.name }}</span>
                </div>
              </el-option>
            </el-select>
            <div>
              <span class="option-label">背景颜色</span>
              <el-radio-group v-model="currentComponent.backgroundType" class="color-config-bgc" @change="handleBackgroundType">
                <el-radio-button :label="1">纯色</el-radio-button>
                <el-radio-button :label="2">模版</el-radio-button>
                <el-radio-button :label="3">图片</el-radio-button>
              </el-radio-group>
            </div>

            <div v-if="currentComponent.backgroundType === 1" class="background-color">
              <span class="option-label">背景</span>
              <el-color-picker v-model="currentComponent.background" :predefine="COLOR_PICKER_LIST" class="color-select" />
            </div>
            <div v-if="currentComponent.backgroundType === 2" class="background-template">
              <span class="option-label text">选择模版</span>
              <div class="template-select">
                <el-select ref="selectTemplate" v-model="currentComponent.background" class="template-select-setting" style="display:block; width: 220px;" @change="handleBackground">
                  <el-option v-for="(item,index) in BACKGROUND_TEMPLATE_LIST" :key="index" :value="item" :label="' '">
                    <img :src="item" alt="" style="display:block;width: 180px;height:100px" />
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="currentComponent.backgroundType === 3" class="background-img">
              <span class="option-label">上传图片</span>
              <Single v-model="currentComponent.background" accept="image/jpeg, image/png, image/jpg" :max-size="form.panelWidth*form.panelHeight"></Single>
            </div>
          </div>
        </el-collapse-item>
        <!-- 交互 -->
        <el-collapse-item title="交互" name="4">
          <div class="active-config">
            <span class="option-label">自动跳转</span>
            <el-select v-model="currentComponent.jumpPanelSn" placeholder="选择数据大屏" class="active-config-jump" style="width: 220px" clearable @clear="handleClearJump">
              <el-option v-for="(item,index) in screenList" :key="index" :value="item.panelSn" :label="item.panelName"></el-option>
            </el-select>
            <div v-if="currentComponent.jumpPanelSn">
              <span class="option-label">跳转延迟</span>
              <el-input v-model="currentComponent.jumpDelaySecond" class="jump-delay" style="width: 220px"> <span slot="suffix">s</span></el-input>
            </div>
          </div>
        </el-collapse-item>
      </div>

      <!-- 组件设置 -->
      <div v-else key="component">
        <!-- 尺寸 -->
        <el-collapse-item title="尺寸" name="1">
          <div class="component-size">
            <span class="option-size-label">位置</span>
            <span class="opti-sub-label">x</span>
            <el-input-number
              v-model="componentSizeSet.x"
              controls-position="right"
              @blur="setComponentSize"
              @change="setComponentSize"
              @keyup.enter.native="setComponentSize">
            </el-input-number>
            <span class="opti-sub-label">y</span>
            <el-input-number
              v-model="componentSizeSet.y"
              controls-position="right"
              @blur="setComponentSize"
              @change="setComponentSize"
              @keyup.enter.native="setComponentSize">
            </el-input-number>
          </div>
          <div class="component-size">
            <span class="option-size-label">尺寸</span>
            <span class="opti-sub-label">w</span>
            <el-input-number
              v-model="componentSizeSet.w"
              controls-position="right"
              @blur="setComponentSize"
              @change="setComponentSize"
              @keyup.enter.native="setComponentSize">
            </el-input-number>
            <span class="opti-sub-label">h</span>
            <el-input-number
              v-model="componentSizeSet.h"
              controls-position="right"
              @blur="setComponentSize"
              @change="setComponentSize"
              @keyup.enter.native="setComponentSize">
            </el-input-number>
          </div>
        </el-collapse-item>
        <!-- 标题 -->
        <el-collapse-item v-if="componentType !== 'imageBlock'" title="标题" name="5">
          <div class="title-config">
            <div class="title-config-title">
              <span class="option-label">标题</span>
              <el-input v-model="currentComponent.chartTitle" class="title-label-input" :maxlength="30"></el-input>
            </div>
            <el-color-picker
              v-model="currentComponent.chartSet.titleStyle.color"
              :predefine="COLOR_PICKER_LIST" class="title-config-color" />
            <el-select v-model="currentComponent.chartSet.titleStyle.fontSize" class="title-config-fontsize" style="width: 80px">
              <el-option v-for="item in FONT_SIZE_LIST" :key="item" :value="item" :label="item+'px'"></el-option>
            </el-select>
            <el-radio-group v-model="currentComponent.chartSet.titleStyle.align" class="set-position">
              <el-radio-button label="left">
                <Icon icon="zu33707" class="1icon"></Icon>
              </el-radio-button>
              <el-radio-button label="center">
                <Icon icon="zu33708" class="icon"></Icon>
              </el-radio-button>
              <el-radio-button label="right">
                <Icon icon="zu33709" class="icon"></Icon>
              </el-radio-button>
            </el-radio-group>
            <div v-if="!['number','independentNumber','gaugeNumber'].includes(componentType)" class="style-config-border">
              <span class="option-label">标题样式</span>
              <el-radio-group v-model="currentComponent.chartSet.borderStyle.border" @change="handleBorderType">
                <el-radio label="none">无边框</el-radio>
                <el-radio label="template">模版</el-radio>
              </el-radio-group>
              <div v-if="currentComponent.chartSet.borderStyle.border === 'template'" class="set-template">
                <el-select ref="borderTemplate" v-model="currentComponent.chartSet.borderStyle.borderTemplate" class="set-template-select" style="display:block; width: 220px" @change="handleBorder">
                  <el-option v-for="(item,index) in BORDER_TEMPLATE_LIST" :key="index" :value="item" :label="' '">
                    <img :src="item" alt="" style="display:block;width: 200px;" />
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <!-- 样式 -->
        <el-collapse-item v-if="componentType !== 'text' && componentType !== 'imageBlock'" title="样式" name="6">
          <div class="style-config">
            <!-- 组件内文字 -->
            <div v-if="!['text'].includes(componentType)" class="style-config-border">
              <span class="option-label">组件文字</span>
              <el-color-picker
                v-if="['number','independentNumber','gaugeNumber'].includes(componentType)"
                v-model="currentComponent.chartSet.chartStyle.color"
                :predefine="COLOR_PICKER_LIST" class="style-config-numberColor" />
              <el-select v-model="currentComponent.chartSet.chartStyle.fontSize" style="width: 80px">
                <el-option v-for="item in FONT_SIZE_LIST" :key="item" :value="item" :label="item+'px'"></el-option>
              </el-select>
            </div>
            <!-- 纯数字、独立数字 -->
            <div v-if="['independentNumber','gaugeNumber'].includes(componentType)" class="style-config-border">
              <span class="option-label">边框颜色</span>
              <el-color-picker
                v-model="currentComponent.chartSet.borderStyle.color"
                :predefine="COLOR_PICKER_LIST" class="style-config-borderColor" />
            </div>
            <!-- 独立数字 -->
            <div v-if="['independentNumber'].includes(componentType)" class="style-config-border">
              <span class="option-label">边框样式</span>
              <el-select ref="independentNumberSelectType" v-model="currentComponent.chartSet.borderStyle.numberBorderType" style="width: 220px" @change="handleIndependentNumberSelectType">
                <el-option v-for="item in INDEPENDENT_NUMBER_BORDER_LIST" :key="item.value" :value="item.value" :label="' '">
                  <Icon :icon="item.label"></Icon>
                </el-option>
              </el-select>
            </div>

            <!-- 纯数字 -->
            <div v-if="['number'].includes(componentType)" class="style-config-border">
              <span class="option-label">单位</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.hasSymbol"></el-switch>
              <template v-if="currentComponent.chartSet.chartStyle.hasSymbol">
                <el-input v-model="currentComponent.chartSet.chartStyle.symbolText" placeholder="请输入单位" style="width: 140px;" maxlength="5" class="style-config-symbol-input"></el-input>
              </template>
            </div>
            <!-- 纯数字 -->
            <div v-if="['number'].includes(componentType) && currentComponent.chartSet.chartStyle.hasSymbol" class="style-config-border">
              <span class="option-label"></span>
              <el-color-picker
                v-model="currentComponent.chartSet.chartStyle.symbolColor"
                :predefine="COLOR_PICKER_LIST" class="style-config-symbolColor" />
              <el-select v-model="currentComponent.chartSet.chartStyle.symbolFontSize" class="style-config-symbol-font">
                <el-option v-for="item in FONT_SIZE_LIST" :key="item" :value="item" :label="item+'px'"></el-option>
              </el-select>
            </div>
            <!-- 纯数字 -->
            <div v-if="['number'].includes(componentType) && currentComponent.chartSet.chartStyle.hasSymbol" class="style-config-border">
              <span class="option-label">单位位置</span>
              <el-radio-group v-model="currentComponent.chartSet.chartStyle.symbolPosition" @change="handleBorderType">
                <el-radio label="left">左</el-radio>
                <el-radio label="right">右</el-radio>
              </el-radio-group>
            </div>

            <!-- 地图 -->
            <div v-if="['mapChart'].includes(componentType) " class="style-config-border">
              <span class="option-label">行政区划</span>
              <el-cascader
                v-model="currentComponent.chartSet.chartStyle.map"
                style="width: 220px; "
                :options="mapChartChooseList"
                :show-all-levels="false"
                :props="{ checkStrictly: true,value:'code',label:'name' }"
                @change="handleMapSourceChange" />
            </div>
            <!-- 地图 -->
            <div v-if="['mapChart','heatMapChart'].includes(componentType)" class="style-config-border">
              <span class="option-label">缩放比例</span>
              <el-input-number v-model="currentComponent.chartSet.chartStyle.zoom" show-input :max="10" :step="0.1" controls-position="right"> </el-input-number>
            </div>
            <!-- 热力图（实际是散点图） -->
            <div v-if="['heatMapChart'].includes(componentType)" class="style-config-border">
              <span class="option-label">地图样式</span>
              <el-select v-model="currentComponent.chartSet.chartStyle.mapStyle" style="width: 130px">
                <el-option v-for="item in AMAP_STYLE_LIST" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </div>
            <!-- 热力图（实际是散点图） -->
            <div v-if="['heatMapChart'].includes(componentType) " class="style-config-border">
              <span class="option-label">高亮</span>
              <el-input-number v-model="currentComponent.chartSet.chartStyle.highlightCount" :min="0" style="width:130px;" :step="1" controls-position="right"></el-input-number>
            </div>
            <!-- 热力图（实际是散点图） -->
            <div v-if="['heatMapChart'].includes(componentType) " class="style-config-border">
              <span class="option-label">中心经度</span>
              <el-input-number v-model="currentComponent.chartSet.chartStyle.lng" :min="0" style="width:130px;" :step="1" controls-position="right"></el-input-number>
            </div>
            <!-- 热力图（实际是散点图） -->
            <div v-if="['heatMapChart'].includes(componentType) " class="style-config-border">
              <span class="option-label">中心纬度</span>
              <el-input-number v-model="currentComponent.chartSet.chartStyle.lat" :min="0" style="width:130px;" :step="1" controls-position="right"></el-input-number>
            </div>

            <!-- 纯数字 独立数字 仪表板 滚动列表 之外 -->
            <div v-if="!['number','independentNumber','gaugeNumber','scrollTable','rank'].includes(componentType)" class="style-config-border">
              <span class="option-label">标签</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.isLabel"></el-switch>
            </div>
            <!-- 饼图 环形图 -->
            <div v-if="['pie','pieCircular'].includes(componentType) && currentComponent.chartSet.chartStyle.isLabel" class="style-config-border">
              <span class="option-label">标签内容</span>
              <el-radio-group v-model="currentComponent.chartSet.chartStyle.labelContent">
                <el-radio label="number">数据</el-radio>
                <el-radio label="percent">占比</el-radio>
              </el-radio-group>
            </div>
            <!-- 饼图 环形图 -->
            <div v-if="['pie','pieCircular','verticalBar','line','areaLine'].includes(componentType)" class="style-config-border">
              <span class="option-label">图例展示</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.isLegend"></el-switch>
              <el-radio-group
                v-if="['pie','pieCircular'].includes(componentType) && currentComponent.chartSet.chartStyle.isLegend"
                v-model="currentComponent.chartSet.chartStyle.legendPosition" style="margin-left: 10px">
                <el-radio label="top">上方</el-radio>
                <el-radio label="right">右侧</el-radio>
              </el-radio-group>
            </div>

            <!-- 支持图例展示时设置 图例文字的大小 -->
            <div v-if="currentComponent.chartSet.chartStyle.isLegend" class="style-config-border">
              <span class="option-label">图例文字</span>
              <el-select v-model="currentComponent.chartSet.chartStyle.legendSize" style="width: 80px">
                <el-option v-for="item in fontSmallSize" :key="item" :value="item" :label="item+'px'"></el-option>
              </el-select>
            </div>

            <!-- 面积图 折线图 -->
            <div v-if="['areaLine','line'].includes(componentType)" class="style-config-border">
              <span class="option-label">平滑曲线</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.smooth"></el-switch>
            </div>

            <!--  折线图 -->
            <div v-if="['line'].includes(componentType)" class="style-config-border">
              <span class="option-label">支持双轴</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.doubleAxis"></el-switch>
            </div>

            <!--  仪表板 -->
            <div v-if="['gaugeNumber'].includes(componentType)" class="style-config-border">
              <span class="option-label">轴标签</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.axisLabel"></el-switch>
            </div>

            <!-- 横向、纵向柱状图 -->
            <div v-if="['horizonBar','verticalBar',].includes(componentType)" class="style-config-border">
              <span class="option-label">柱形宽度</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.borderWidth" show-input> </el-slider>
            </div>
            <!-- 横向、纵向柱状图 -->
            <div v-if="['horizonBar','verticalBar',].includes(componentType)" class="style-config-border">
              <span class="option-label">柱形圆角</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.borderRadius" show-input> </el-slider>
            </div>

            <!-- 仪表板 极坐标 排行榜 -->
            <div v-if="['gaugeNumber','barPolar','rank'].includes(componentType)" class="style-config-border">
              <span class="option-label">最大值</span>
              <el-input v-model="theMax" placeholder="请输入" style="width: 117px" @blur="handleChangeMax" @keyup.enter.native="handleChangeMax" @keyup.native="theMax = theMax.replace(/[^\d]/g,'')"></el-input>
            </div>

            <!-- 排行榜 -->
            <div v-if=" ['rank'].includes(componentType)" class="style-config-border">
              <span class="option-label">榜单个数</span>
              <el-input v-model="currentComponent.chartSet.chartStyle.setRankNumber" :max="5" placeholder="请输入" style="width: 117px"></el-input>
            </div>

            <!-- 仪表板 排行榜 -->
            <div v-if=" ['gaugeNumber','rank'].includes(componentType)" class="style-config-border">
              <span class="option-label">单位</span>
              <el-input v-model="currentComponent.chartSet.chartStyle.unit" :max="5" placeholder="请输入" style="width: 117px"></el-input>
            </div>

            <!-- 饼图 -->
            <div v-if="['pie'].includes(componentType)" class="style-config-border">
              <span class="option-label">半径大小</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.radius" show-input> </el-slider>
            </div>
            <!-- 极坐标 环形图 -->
            <div v-if="['barPolar','pieCircular'].includes(componentType)" class="style-config-border">
              <span class="option-label">内径大小</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.internalRadius" show-input> </el-slider>
            </div>
            <!-- 极坐标 环形图 -->
            <div v-if="['barPolar','pieCircular'].includes(componentType) " class="style-config-border">
              <span class="option-label">外径大小</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.externalRadius" show-input> </el-slider>
            </div>

            <!-- 饼图、环形图、排行榜 -->
            <div v-if="['pie','pieCircular','rank',].includes(componentType)" class="style-config-border">
              <span class="option-label">比率显示</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.setRate" @change="handleRankRate"></el-switch>

              <el-radio-group
                v-if="['rank'].includes(componentType) && currentComponent.chartSet.chartStyle.setRate"
                v-model="currentComponent.chartSet.chartStyle.rateType" style="margin-left: 10px">
                <el-radio label="yearRate">同比</el-radio>
                <el-radio label="quarterRate">环比</el-radio>
              </el-radio-group>
              <el-color-picker
                v-if="['rank'].includes(componentType) && currentComponent.chartSet.chartStyle.setRate "
                v-model="currentComponent.chartSet.chartStyle.rateColor"
                :predefine="COLOR_PICKER_LIST" class="style-config-rateColor" />
            </div>
            <!-- 滚动列表 -->
            <div v-if="componentType ==='scrollTable'" class="style-config-border">
              <span class="option-label">斑马纹</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.stripe"></el-switch>
            </div>

            <!-- 滚动列表 折线图 -->
            <div v-if="['scrollTable','line'].includes(componentType)" class="style-config-border">
              <span class="option-label">关联地图</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.isLinkMap" @change="handleLinkMapSwitch" />
              <el-select
                v-if="currentComponent.chartSet.chartStyle.isLinkMap"
                v-model="currentComponent.chartSet.chartStyle.linkMap"
                placeholder="请选择地图组件"
                class="link-map-select"
                @change="handleLinkMapChange">
                <el-option
                  v-for="(item,i) in mapComponentList"
                  :key="i"
                  :label="item.chartTitle || '未命名地图组件'"
                  :value="item.addSn" />
              </el-select>
            </div>
          </div>
        </el-collapse-item>
        <!-- 交互 -->
        <el-collapse-item title="交互" name="7">
          <div v-if="!['number','independentNumber','gaugeNumber','scrollTable','text'].includes(componentType) " class="active-config">
            <span class="option-label">轮播</span>
            <el-switch v-model="currentComponent.chartSet.chartStyle.carousel" :disabled="['mapChart'].includes(componentType)"></el-switch>
            <el-input-number v-model="currentComponent.chartSet.chartStyle.carouselDelay" :min="3" style="margin-left:10px;width:100px;" :step="0.5" controls-position="right"></el-input-number> 秒
          </div>

          <div v-if="componentType === 'scrollTable'" class="active-config">
            <span class="option-label">是否滚动</span>
            <el-switch v-model="currentComponent.chartSet.chartStyle.isScroll"></el-switch>
          </div>
          <template v-if="currentComponent.chartSet.chartStyle.isScroll">
            <div v-if="componentType === 'scrollTable'" class="active-config">
              <span class="option-label">鼠标悬停</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.hoverStop"></el-switch>
            </div>

            <div v-if="componentType === 'scrollTable'" class="active-config">
              <span class="option-label">滚动速度</span>
              <el-input-number v-model="currentComponent.chartSet.chartStyle.step" :step="0.1" controls-position="right"></el-input-number>
            </div>
          </template>
          <div class="active-config">
            <span class="option-label">点击跳转</span>
            <el-select ref="selectScreen" v-model="currentComponent.jumpPanelSn" placeholder="选择数据大屏" class="active-config-jump" style="width: 220px; background-color:#fff" clearable>
              <el-option v-for="(item,index) in screenList" :key="index" :value="item.panelSn" :label="item.panelName"></el-option>
            </el-select>
          </div>
        </el-collapse-item>
        <!-- 数据 -->
        <el-collapse-item v-if="componentType !== 'text'" title="数据" name="8">
          <div class="data-config">
            <div v-if="needUpdateMapRelate" class="map-change-tips">
              <i class="el-icon-warning" /><span>关联地图组件的行政区划已调整，点击“更新”获取新的行政区划，系统将自动清空原行政区划的数据，更新后录入新数据。</span>
            </div>
            <div v-if="componentType === 'mapChart' && currentComponent.chartSet.chartStyle.mapChangeTip" class="map-change-tips">
              <i class="el-icon-warning" /><span>行政区划已调整，请更新组件数据。</span>
            </div>
            <el-radio-group v-model="currentComponent.chartSet.dataSource" class="data-source-option" @change="handleDataSourceChange">
              <el-radio label="indicatorLib">指标库</el-radio>
              <el-radio label="customize">自定义</el-radio>
            </el-radio-group>
            <template v-if="currentComponent.chartSet.dataSource==='customize'">
              <div :style="{matginTop:'10px'}">
                <el-button type="primary" @click="handleManageData">管理数据</el-button>
                <el-button v-if="needUpdateMapRelate" type="primary" plain @click="handleUpdateMapData">更新</el-button>
              </div>
              <div class="data-config-title">数据预览</div>
              <!-- 单数据源 -->
              <template v-if="!isMultipleChartData">
                <el-table
                  :key="uniqueKey"
                  v-loading="currentComponent.chartViewData.initDataFlag"
                  element-loading-text="初始数据请重置"
                  element-loading-spinner=" "
                  element-loading-background="rgba(0, 0, 0, .3)"
                  class="manage-table"
                  stripe
                  border
                  :max-height="200"
                  :show-header="true"
                  :data="currentTableData">
                  <el-table-column
                    v-for="(key,i) in Object.keys(currentTableHeader)"
                    :key="i"
                    :prop="key">
                    <template #header>
                      <!-- 表头 -->
                      <span class="cell-content">{{ currentTableHeader[key] }}
                        <span v-if="currentComponent.chartSet.chartStyle.doubleAxis && key !=='col_0'" class="axis-label">
                          {{ currentComponent.chartViewData.chartData.setAxis && currentComponent.chartViewData.chartData.setAxis[key] ? 'y2':'y1' }}
                        </span>
                      </span>
                    </template>
                    <!-- Cell -->
                    <template slot-scope="scope">
                      <span class="cell-content">{{ scope.row[key] }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
              <!-- 多数据源 -->
              <template v-else>
                <el-tabs tab-position="left">
                  <el-tab-pane v-for="(item,i) in currentComponent.chartViewData.chartData" :key="i" :label="item.labelName">
                    {{ item.labelName }}
                    <el-table
                      :key="uniqueKey+'_'+i"
                      v-loading="currentComponent.chartViewData.initDataFlag"
                      element-loading-text="初始数据请重置"
                      element-loading-spinner=" "
                      element-loading-background="rgba(0, 0, 0, .3)"
                      class="manage-table"
                      stripe
                      border
                      :max-height="200"
                      :show-header="true"
                      :data="getCurTableData(item.realChartData)">
                      <el-table-column
                        v-for="(key,idx) in Object.keys(item.realChartData[0])"
                        :key="idx"
                        :prop="key">
                        <template #header>
                          <!-- 表头 -->
                          <span class="cell-content">{{ item.realChartData[0][key] }}
                            <span v-if="currentComponent.chartSet.chartStyle.doubleAxis && key !=='col_0'" class="axis-label">
                              {{ item.setAxis && item.setAxis[key] ? 'y2':'y1' }}
                            </span>
                          </span>
                        </template>
                        <!-- Cell -->
                        <template slot-scope="scope">
                          <span class="cell-content">{{ scope.row[key] }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                </el-tabs>
              </template>
            </template>
            <template v-if="currentComponent.chartSet.dataSource==='indicatorLib'">
              <div class="data-indicator">
                <span class="indicator-label">数据指标</span>
                <div class="indicator-content">
                  <div v-for="(item,index) in currentComponent.chartViewData.selectedIndicatorList" :key="index" class="data-config-item">
                    <el-select v-model="item.dataIndicator" filterable :style="{'width': index===0?'220px':'190px' ,'margin-right': index===0? '0px':'5px' }" placeholder="选择指标">
                      <el-option v-for="(optionItem,idx) in currentComponent.dataIndicatorList" :key="idx" :value="optionItem.value" :label="optionItem.label" :disabled="checkIndexDisable(optionItem)"></el-option>
                    </el-select>
                    <Icon v-if="index> 0 " icon="zu34064" class="data-config-del" @click.native="handleDelIndicator(index)"></Icon>
                  </div>
                </div>
              </div>
              <div class="data-indicator indicatior-icon">
                <Icon v-if="['line','areaLine','verticalBar',].includes(componentType) " icon="zu34063" class="data-config-add" @click.native="handleAddIndicator"></Icon>
              </div>
              <div class="data-indicator">
                <span class="indicator-label">指标说明</span>
                <el-switch v-model="currentComponent.chartViewData.showIndicator"></el-switch>
              </div>
            </template>
          </div>
        </el-collapse-item>
      </div>
    </el-collapse>

    <!-- 编辑数据弹窗 -->
    <ManageDataDialog
      v-if="dialogVisible"
      :raw-data="currentComponent.chartViewData.chartData"
      :is-multiple-chart-data="isMultipleChartData"
      :init-data-flag="currentComponent.chartViewData.initDataFlag"
      :double-axis-flag="currentComponent.chartSet.chartStyle.doubleAxis || false"
      @confirm="handleDataConfirm"
      @close="dialogVisible = false" />
  </div>
</template>

<script>
import {
  FONT_SIZE_LIST,
  BACKGROUND_TEMPLATE_LIST,
  BORDER_TEMPLATE_LIST,
  RICH_FONT_SIZE_LIST,
} from '../data'
import _ from 'lodash'
import {
  COLOR_LIST,
  COLOR_PICKER_LIST,
  INDEPENDENT_NUMBER_BORDER_LIST,
  BORDER_TYPE_LIST,
  AMAP_STYLE_LIST,
} from '@/utils/defaultColorData'

import ManageDataDialog from './manageDataDialog.vue'
import { TABLE_HEADER, TABLE_ROW, componentInitDataMap } from '@/utils/defaultComponentConfig'
import {
  getScreenListApi,
  saveComponentDataApi,
} from '../fetch'
import Single from '../../../components/imageUpload/single.vue'
import { needIndexComponent } from '../funcs'
import { mapGetters } from 'vuex'
const MULTIPLE_DATA_INIT = [
  { col_0: '列1', col_1: '列2', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '列8' },
  { col_0: '', col_1: '', col_2: '', col_3: '', col_4: '', col_5: '', col_6: '', col_7: '' },
]

export default {
  name: 'PaneConfig',
  components: {
    ManageDataDialog,
    Single,
  },
  props: {
    relateMap: {
      type: Object,
    },
    currentComponent: {
      type: Object,
    },
    mapComponentList: {
      type: Array,
    },
    screenConfig: {
      type: Object,
    },
    screenData: {
      type: Array,
    },
  },
  data () {
    const validateSize = (rule, value, callback) => {
      const { field } = rule
      if (value > 5000) {
        this.form[field] = 5000
      } else if (value < 100) {
        this.form[field] = 100
      }
      this.currentComponent[field] = this.form[field]
      callback()
    }
    // 默认的指标
    const indicator = { dataIndicator: '' }
    return {
      initIndicator: _.cloneDeep(indicator),
      // 富文本字体大小
      RICH_FONT_SIZE_LIST,
      // 高德地图样式
      AMAP_STYLE_LIST,
      componentSizeSet: {
        w: '',
        h: '',
        x: '',
        y: '',
      },
      chartDataBak: null,
      uniqueKey: 8090,
      dialogVisible: false,
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'],
      FONT_SIZE_LIST,
      COLOR_LIST,

      // color-picker 预定义颜色
      COLOR_PICKER_LIST,

      // 独立数字组件边框样式下拉
      INDEPENDENT_NUMBER_BORDER_LIST,

      // 边框组件边框样式
      BORDER_TYPE_LIST,

      //  大屏背景模板
      BACKGROUND_TEMPLATE_LIST,

      //  组件边框模板
      BORDER_TEMPLATE_LIST,
      form: {
        panelWidth: 1920,
        panelHeight: 1080,
      },
      rules: {
        panelWidth: [
          { required: false, validator: validateSize, trigger: 'blur' },
        ],
        panelHeight: [
          { required: false, validator: validateSize, trigger: 'blur' },
        ],
      },
      theMax: 100,
      screenList: [],
      screenId: this.$route.params.id, // 大屏id
      initChartData: [],
      needSyncCache: {},
      needUpdateMapRelate: false,
    }
  },
  computed: {
    ...mapGetters(['regionInfo']),
    mapChartChooseList () {
      return ([{ code: '100000', name: '全国', children: [...this.regionInfo] }])
    },
    currentTableHeader () {
      return this.currentChartData?.length ? this.currentChartData[0] : []
    },
    currentTableData () {
      return this.currentChartData?.length ? this.currentChartData.slice(1) : []
    },
    componentType () {
      return this.currentComponent.chartComponent
    },
    currentComponentStyle () {
      return this.currentComponent.chartSet
    },
    isMultipleChartData () {
      return !!this.currentChartData?.[0]?.labelName
    },
    currentChartData () {
      const data = this.currentComponent.chartViewData.chartData
      return data?.setAxis ? data.realChartData : data
    },
    fontSmallSize () {
      const sizeList = _.cloneDeep(FONT_SIZE_LIST)
      return sizeList.splice(0, 5)
    },
  },
  watch: {
    currentComponent: {
      handler: function (newValue, oldValue) {
        this.needUpdateMapRelate = false
        this.componentSizeSet = {
          x: this.currentComponent.chartX,
          y: this.currentComponent.chartY,
          w: this.currentComponent.chartWidth,
          h: this.currentComponent.chartHeight,
        }

        // 判断组件是否关联地图，
        if (this.currentComponent.chartSet?.chartStyle.linkMap) {
          // 通过匹配等待同步的缓存，检测当前组件关联的地图组件行政区划是否修改
          const isFindMe = this.needSyncCache[this.currentComponent.addSn]
          if (isFindMe) {
            if (isFindMe !== this.currentComponent.chartSet.chartStyle.map) {
              this.needUpdateMapRelate = true
            }
          }
        }
        // 组件使用指标库数据
        if (newValue.chartViewData && needIndexComponent(newValue.chartComponent)) {
          const list = newValue.chartViewData?.selectedIndicatorList ?? []
          this.$set(newValue.chartViewData, 'selectedIndicatorList', list)
          if (!newValue.chartViewData?.selectedIndicatorList?.length) {
            newValue.chartViewData.selectedIndicatorList.push(_.cloneDeep(this.initIndicator))
          }
        }

        this.$nextTick(async () => {
          this.form.panelHeight = this.currentComponent.panelHeight
          this.form.panelWidth = this.currentComponent.panelWidth
          // 设置 色卡、大屏背景、组件边框 的模板回填
          if (!this.currentComponent.chartViews) {
            this.theMax = this.currentComponent.chartSet?.chartStyle.max
            if (this.currentComponentStyle?.borderStyle.borderTemplate) {
              this.handleBorder(this.currentComponentStyle.borderStyle.borderTemplate)
            }
            this.initChartData = _.cloneDeep(this.currentComponent.chartViewData.chartData)
          } else {
            // 大屏设置
            this.handleThemeColor(this.currentComponent.chartColors)
            if (this.currentComponent.backgroundType === 2) {
              this.handleBackground(this.currentComponent.background)
            }
          }
        })
      },
      deep: true,
    },
    componentType: {
      handler: async function (newValue, oldValue) {
        // 独立数字组件, 设置其边框样式
        if (['independentNumber'].includes(newValue)) {
          this.$nextTick(async () => {
            this.handleIndependentNumberSelectType(this.currentComponent.chartSet.borderStyle.numberBorderType)
          })
        }
        // 边框组件, 设置边角样式
        if (['borderBlock'].includes(newValue) && this.currentComponent.chartSet.chartStyle.hasCorner) {
          this.$nextTick(async () => {
            this.handleBorderSelectType(this.currentComponent.chartSet.chartStyle.borderType)
          })
        }
      },
      deep: true,
    },
  },
  mounted () {
    this.init()
  },

  methods: {
    // 检查指标是否已被使用
    checkIndexDisable (item) {
      return this.currentComponent.chartViewData.selectedIndicatorList?.map(bar => bar?.dataIndicator).includes(item.value)
    },
    // 阻止键盘事件向上冒泡
    handleKeyDown (e) {
      e.stopPropagation()
    },
    async init () {
      // 初始化配置项并回填
      const list = await getScreenListApi()
      this.screenList = list.filter(item => {
        return item.panelSn !== this.screenId
      })
    },
    handleScreenSizeChange (val) {
      const map = {
        '16:9': { w: 1920, h: 1080 },
        '4:3': { w: 1920, h: 1440 },
        custom: { w: 1920, h: 1080 },
      }
      if (this.val !== 'custom') {
        this.form.panelWidth = map[val].w
        this.form.panelHeight = map[val].h
        this.currentComponent.panelWidth = map[val].w
        this.currentComponent.panelHeight = map[val].h
      }
    },
    // 设置背景方式
    handleBackgroundType (val) {
      switch (val) {
        case 1:
          this.currentComponent.background = '#071228'
          break
        case 2:
          this.currentComponent.background = 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background1.png'
          break
        default:
          this.currentComponent.background = ''
          break
      }
    },
    // 选择背景模板，回填模板图片
    handleBackground (val) {
      this.$refs.selectTemplate
        .$el.children[0]
        .children[0]
        .setAttribute(
          'style',
				`background: url(${val}) no-repeat;background-position: 10px center; background-size: 80% 80%;text-indent: 30px;
        width: 220px; height: 80px;`,
        )
    },

    // 选择组件配色，回填颜色图片
    handleThemeColor (val) {
      const optionsImg = this.COLOR_LIST
      const i = optionsImg.find((item) => item.label === val).number
      const url = `https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color${i}.svg`
      this.$refs.selectColor.$el.children[0].children[0].setAttribute('style', `background: url(${url}) no-repeat;background-position: 10px center; background-size: 80% 80%;text-indent: 30px;`)
    },

    // 选择独立数组组件边框样式，回填边框样式
    handleIndependentNumberSelectType (val) {
      const url = `https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/numberBorderType${val}.svg`
      this.$refs.independentNumberSelectType.$el.children[0].children[0].setAttribute('style', `background: url(${url}) no-repeat;background-position: 10px center; background-size: 80% 80%;text-indent: 30px;background-color: #fff;`)
    },

    // 边框组件边框样式，回填边角样式
    handleBorderSelectType (val) {
      const url = `https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/tempBorderType${val}.svg`
      this.$refs.borderSelectType.$el.children[0].children[0].setAttribute('style', `background: url(${url}) no-repeat;background-position: 10px center; background-size: 80% 80%;text-indent: 30px; background-color: #fff;`)
    },

    // 如果显示边角 回填边角样式
    handleChangeHasCorner (val) {
      if (val) {
        this.$nextTick(async () => {
          this.handleBorderSelectType(this.currentComponent.chartSet.chartStyle.borderType)
        })
      }
    },

    // 数据确认(自定义数据)
    async handleDataConfirm (data, setAxis) {
      this.currentComponent.chartViewData.initDataFlag = 0
      if (this.currentComponent.chartSet.chartStyle.doubleAxis && !this.currentComponent.chartSet.chartStyle.linkMap) {
        this.currentComponent.chartViewData.chartData = { realChartData: data, setAxis }
      } else {
        this.currentComponent.chartViewData.chartData = data
      }

      const params = _.cloneDeep(this.currentComponent.chartViewData)
      params.chartData = JSON.stringify(params.chartData)
      params.initData = JSON.stringify(params.initData)
      await saveComponentDataApi(params)
      this.uniqueKey += 1 // 解决表头数据更新但表头不更新

      // 地图修改行政区划后，提示需要在数据再次保存后清除
      if (this.componentType === 'mapChart') {
        this.currentComponent.chartSet.chartStyle.mapLocalBak = this.currentComponent.chartSet.chartStyle.map.join('/')
        this.currentComponent.chartSet.chartStyle.mapChangeTip = undefined
      }

      // 在确认数据之后，将榜单图的最大值设置为第一个数据
      if (this.componentType === 'rank') {
        this.currentComponent.chartSet.chartStyle.max = data[1].col_1
      }
    },

    handleManageData () {
      this.dialogVisible = true
    },
    changeComponentTitle (value) {
      this.currentComponent.chartTitle = value
    },
    handleChangeMax () {
      if (this.currentComponent.chartSet) {
        this.currentComponent.chartSet.chartStyle.max = +this.theMax
      }
    },

    // 标题样式回填
    handleBorder (val) {
      this.$refs.borderTemplate
        .$el.children[0]
        .children[0]
        .setAttribute(
          'style',
				`background: url(${val}) no-repeat;background-position: 10px center; background-size: 80% 80%;text-indent: 30px;
         width: 220px; height: 30px;`,
        )
    },
    handleBorderType (val) {
      if (val === 'none') {
        this.currentComponent.chartSet.borderStyle.borderTemplate = ''
      }
    },
    handleClearJump () {
      this.currentComponent.jumpDelaySecond = null
    },
    handleSubmit () {
      this.$refs.screenSizeForm.validate()
    },

    handleLinkMapSwitch (val) {
      if (val) { // 打开关联地图
        // 备份单数据源的数据
        this.chartDataBak = _.cloneDeep(this.currentComponent.chartViewData.chartData)
      } else { // 关闭关联地图
        this.currentComponent.chartSet.chartStyle.linkMap = undefined
        if (this.chartDataBak) {
          this.currentComponent.chartViewData.chartData = _.cloneDeep(this.chartDataBak)
        } else {
          this.currentComponent.chartViewData.chartData = _.cloneDeep([TABLE_HEADER, TABLE_ROW])
        }
      }
    },

    // 关联地图的组件重新获取地图数据
    handleUpdateMapData () {
      this.handleLinkMapChange(this.currentComponent.chartSet.chartStyle.linkMap)
      this.needUpdateMapRelate = false
      this.needSyncCache[this.currentComponent.addSn] = undefined
    },

    // 组件选择关联地图组件
    async handleLinkMapChange (mapAddSn) {
      const map = this.mapComponentList.find(bar => bar.addSn === mapAddSn).chartSet.chartStyle.map.join('/')
      const mapJsonRes = await fetch(`https://kylin-static.oss-cn-hangzhou.aliyuncs.com/common/geojson/${map}.json`)
      const mapJson = await mapJsonRes.json()
      const mapLabelList = mapJson.features.map(bar => bar.properties.name)

      const multipleDataList = mapLabelList.map(labelName => {
        return {
          labelName,
          setAxis: {},
          realChartData: _.cloneDeep(MULTIPLE_DATA_INIT),
        }
      })
      this.currentComponent.chartViewData.chartData = multipleDataList
      this.currentComponent.chartSet.chartStyle.map = map

      // 记录地图组件与其他组件依赖关系
      if (this.relateMap[mapAddSn]) {
        this.relateMap[mapAddSn].push(this.currentComponent.addSn)
        this.relateMap[mapAddSn] = [...new Set(this.relateMap[mapAddSn])]
      } else {
        this.relateMap[mapAddSn] = [this.currentComponent.addSn]
      }
    },
    // 获取表格数据
    getCurTableData (table) {
      return table.slice(1)
    },
    handleRankRate (value) {
      if (!value && this.componentType === 'rank') {
        this.currentComponent.chartSet.chartStyle.rateType = ''
      }
    },
    // 地图行政区划更新，将相关联的组件加入到等待同步的缓存中
    handleMapSourceChange (map) {
      // 地图组件 修改行政区划 并且不是初始数据 不是原来的行政区域 需提示，
      if (!this.currentComponent.chartViewData.initDataFlag && map.join('/') !== this.currentComponent.chartSet.chartStyle.mapLocalBak) {
        this.currentComponent.chartSet.chartStyle.mapChangeTip = true
      } else {
        this.currentComponent.chartSet.chartStyle.mapChangeTip = false
      }

      // 地图行政区划更新后，将相关联的组件加入到等待同步的缓存中
      const updateComp = this.relateMap[this.currentComponent.addSn] || []
      updateComp.forEach(bar => {
        this.needSyncCache[bar] = map.join('/')
      })
    },

    // 组件尺寸赋值
    setComponentSize () {
      this.componentSizeSet.w = this.componentSizeSet.w > this.screenConfig.panelWidth
        ? this.screenConfig.panelWidth
        : this.componentSizeSet.w
      this.componentSizeSet.h = this.componentSizeSet.h > this.screenConfig.panelHeight
        ? this.screenConfig.panelHeight
        : this.componentSizeSet.h

      this.componentSizeSet.x = this.componentSizeSet.x > this.screenConfig.panelWidth - this.componentSizeSet.w
        ? this.screenConfig.panelWidth - this.componentSizeSet.w
        : this.componentSizeSet.x

      this.componentSizeSet.y = this.componentSizeSet.y > this.screenConfig.panelHeight - this.componentSizeSet.h
        ? this.screenConfig.panelHeight - this.componentSizeSet.h
        : this.componentSizeSet.y

      this.currentComponent.chartX = +this.componentSizeSet.x
      this.currentComponent.chartY = +this.componentSizeSet.y
      this.currentComponent.chartWidth = +this.componentSizeSet.w
      this.currentComponent.chartHeight = +this.componentSizeSet.h
    },

    handleFontStyle (style) {
      this.currentComponent.chartSet.titleStyle.fontStyle[style] = Math.random()
    },
    handleJustify (style) {
      this.currentComponent.chartSet.titleStyle.align = style
    },
    // 增加数据指标维度
    handleAddIndicator () {
      const empty = this.currentComponent.chartViewData.selectedIndicatorList?.every(item => !item.dataIndicator)
      if (empty) {
        this.$error('请选择数据指标之后再添加')
      }
      this.currentComponent.chartViewData.selectedIndicatorList.push(_.cloneDeep(this.initIndicator))
    },

    // 删除数据指标维度
    handleDelIndicator (index) {
      this.currentComponent.chartViewData.selectedIndicatorList.splice(index, 1)
    },
    // 数据源切换
    handleDataSourceChange (value) {
      if (value === 'customize') {
        this.currentComponent.chartViewData.selectedIndicatorList = []
        this.currentComponent.chartViewData.showIndicator = false
        if (!this.currentComponent.chartViewData?.initData) {
          this.currentComponent.chartViewData.initData = componentInitDataMap.get(this.currentComponent.chartComponent)
        }
        this.currentComponent.chartViewData.chartData = _.cloneDeep(this.currentComponent.chartViewData.initData)
      }
    },
    // 输入签名名称改变的时候同时改变签名URL
    handleChangeSignName (value) {
      this.currentComponent.chartSet.chartStyle.signUrl = `${process.env.VUE_APP_SIGN_URL}/draw/${this.screenId}?name=${encodeURIComponent(value)}`
    },
    handleChangeFilterType (value) {
      // 获取当前非激活状态的筛选框
      const filterBlocks = this.screenData.filter(bar => bar.chartComponent === 'filterBlock' && !bar.active)
      const repeated = filterBlocks.some(bar => bar.chartSet.chartStyle.filterType === value)
      if (repeated) {
        this.$error('该类型的过滤器已存在，请更换类型')
        this.currentComponent.chartSet.chartStyle.filterType = ''
      } else {
        this.currentComponent.chartSet.chartStyle.filterType = value
      }
    },

  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.pane-config-wrap{
  display: flex;
  flex-direction: column;
  ::v-deep .el-radio-button__inner{
    width: 110px;
    @media screen and (max-width: 1600px){
      width: 90px;
    }
  }
  .pane-name-icon {
    color: #3269ff;
  }
  .pane-name {
    margin-bottom: 8px;
    &-icon{
      margin-right: 8px;
      font-size: 24px;
    }
    &-title{
      font-weight: bold;
      font-size: 16px;
      vertical-align: 3px;
    }
  }

  .pane-config-container{
    height: 0;
    flex: 1;
    overflow: auto;
    .component-size{
      .option-size-label {
        display: inline-block;
        margin: 10px 12px 10px  0;
      }
      .opti-sub-label{
        display: inline-block;
        width: 20px;
        text-align: right;
        margin-right: 5px;
      }
      .el-input-number{
        width: 98px;
      }
    }
    .component-size,.size-config,.title-config,.color-config,.active-config,.style-config {
      padding-left: 20px;
    }
    .size-config{
      .size-width{
        .size-width-input{
          width: 130px;
          @media screen and (max-width: 1600px) {
            width: 100px;
          }
        }
      }
      .size-label {
        display: inline-block;
        margin: 10px 10px 10px  0;
      }
    }
    .option-label {
      display: inline-block;
      margin: 10px 12px 10px  0;
      width: 52px;
      text-align: right;
    }
    .option-label-slider {
      display: inline-block;
      margin: 5px 10px 0px  0;
    }

    .link-map-select{
      width: 170px;
      margin-left: 10px;
    }

    // 边框组件
    .border-config{
      .border-config-item{
        .el-color-picker{
          vertical-align: middle;
          margin-right: 5px;
        }
        .corner-switch,.border-input{
          margin-right: 5px;
        }
      }
    }

    // 标题
    .title-config{
      .title-label-input{
        width: 236px;
      }

      &-color {
        margin:0  5px 0 64px;
      }
      &-fontsize {
        vertical-align: top;
      }

      .rich-text-style {
        display: inline-block;
        vertical-align: -10px;
      }
      .rich-config-color {
        margin-right: 5px;
      }
      .set-font-style {
        display: inline-block;
        width :238px;
        height: 32px;
        background-color: #fff;
        border-radius: 2px;
        margin-bottom: 5px;
        border:1px solid #e4e7ed;
        border-right: none;

        &-item{
          display: inline-block;
          width: 25%;
          height: 100%;
          text-align: center;
          line-height: 32px;
          border-right:1px solid #e4e7ed;
          cursor: pointer;
          &:hover {
            color: #258aff;
          }
        }

      }
      .set-position {
        margin-left: 5px;
        vertical-align: top;
        ::v-deep .el-radio-button__inner {
          width: 38px !important;
          padding: 8px;
        }
      }

      .set-rich-position {
        display: inline-block;
        width :116px;
        height: 32px;
        margin-left: 5px;
        background-color: #fff;
        border-radius: 2px;
        margin-bottom: 5px;
        vertical-align: 6px;
        border:1px solid #e4e7ed;
        border-right: none;
        vertical-align: 10px;

        &-item{
          display: inline-block;
          width: 33%;
          height: 100%;
          text-align: center;
          line-height: 32px;
          border-right:1px solid #e4e7ed;
          cursor: pointer;
          &:hover {
            color: #258aff;
          }
        }

      }

    }
    // 颜色
    .color-config {
      &-bgc {
        margin: 15px 10px;
      }
      &-select {
        margin-left: 10px;
        background-color: #fff;
        .color-block {
          display: inline-block;
          height: 20px;
          width: 20px;
        }
        .color-name {
          display:inline-block;
        }
      }
      .background-color {
        display: inline;
        .color-select {
          margin-left:10px;
          vertical-align: -10px;
        }
      }
      .background-template{
        .text {
          vertical-align: top;
        }
        .template-select {
          display: inline-block;
          &-setting {
            margin-left: 10px;
            background-color: #fff;
          }
        }
      }
      .background-img{
        display:flex;
        flex-flow:row nowrap;
        align-items:center;
        justify-content: flex-start;
        .option-label{
          display:block;
          width:70px;
          margin-right:20px;
        }
      }
    }
    // 交互
    .active-config {
      &-jump {
       margin-bottom: 10px;
      }
      .jump-delay {
        ::v-deep .el-input__suffix {
          line-height: 32px;
          right: 15px;
        }
      }
    }

    .style-config-border {
      .style-config-borderColor {
        vertical-align: middle;
      }
      .style-config-numberColor {
        margin-right: 5px;
        vertical-align: middle;

      }
      .style-config-rateColor {
        margin-left: 15px;
        vertical-align: middle;

      }
      .style-config-symbol-font{
        margin-left: 5px;
        width: 80px;
      }
      .style-config-symbolColor{
        margin-left: 5px;
        vertical-align: middle;
      }
      .style-config-symbol-input{
        margin-left: 5px;
        width: 60px;
      }
      .set-template {
        padding-left: 64px;
        height: 36px;
        ::v-deep .el-input {
          background-color: #fff !important;
        }

      }
    }

    // 数据管理
    :deep(.data-config){
      padding-right: 20px;
      .data-config-title{
        margin-top: 15px;
      }
      .map-change-tips{
        color: #FF9114;
        font-size: 14px;
        margin-bottom: 10px;
        display: flex;
        align-items: flex-start;
        i{
          font-size: 16px;
          margin-right: 5px;
          width: 16px;
          line-height: 24px;
        }
        span{
          flex: 1;
        }
      }
      .manage-table{
        margin-top: 10px;
        .el-table__header, .el-table__body{
          .el-table__cell{
            height: 32px;
            padding: 0 10px;
            font-size: 12px;
            .cell{
              padding: 0 !important;
              .cell-content{
                @include ellipsis(1);
                .axis-label {
                  color: #ccc;
                  display: inline-block;
                  margin-left: 10px;
                }
              }
            }
          }
        }

      }
    }
  }

  :deep(.el-slider){
    // padding: 0 50px;
    display:inline-block;
    width: 220px;
    vertical-align: middle;
    .el-slider__input {
       width: 105px;
    }
    .el-slider__runway.show-input{
      margin-right: 138px;
    }

  }
  :deep(.el-checkbox-group){
    display: inline-block;
  }

  :deep(.el-collapse) {
    border: none;
    .el-collapse-item__wrap{
      // border: none;
    }

  }
  :deep(.el-collapse-item__header) {
    display: inline-block;
    i {
      float: left;
      line-height: 48px;
    }

  }
}
.data-source-option{
  margin-bottom:20px;
}
.data-indicator{
  display:flex;
  flex-flow:row nowrap;
  align-items:flex-start;
  justify-content: flex-start;
  margin:10px 0;
  .indicator-label{
    display:block;
    margin-right:10px;
    width: 60px;
  }
  .data-config-item{
    margin-bottom:10px;
    display:flex;
    align-items:center;
    justify-content: flex-start;
  }
  &.indicatior-icon{
    padding-left:70px;
    box-sizing:border-box;
  }
  .data-config-del,.data-config-add{
    width:24px;
    height:24px;
  }
}
.sign-name-config{
  .sign-name-config-item{
    display:flex;
    flex-flow:row nowrap;
    align-items:center;
    justify-content: flex-start;
    padding-right:40px;
    box-sizing:border-box;
    .option-label{
      display:block;
      width:90px;
    }
    .sign-content{
      flex:1;
      word-break: break-all;
      line-height:20px;
    }
  }
  .tips{
    padding-left:100px;
    box-sizing:border-box;
    margin:5px 0;
    color:#666;
    font-size:12px;
    line-height:18px;
    word-break: break-all;
  }
}
</style>
